import { useState } from 'react'
import { Form, Button } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { Link } from 'react-router-dom'
import Axios from 'axios'
import { toastSuccess, toastError } from '../../components/swal/toast'
import Version from '../../version'

export function Forgot() {
    const { t } = useTranslation()
    const [email, setEmail] = useState('')
    const [sending, setSending] = useState(false)

    const handleSubmit = async (e) => {
        e.preventDefault()
        setSending(true)
        try {
            await Axios.post(process.env.REACT_APP_DB_ADDRESS + '/api/forgot/send', { email })
            toastSuccess(`${t('forgot.emailsend1')} ${t('forgot.emailsend2')}`)
        } catch (error) {
            toastError(t('forgot.senderror'))
        }
        setSending(false)
    }

    return (
        <div className='login-page'>
            <div className='login-card-wrapper'>
                <div className='login-card'>
                    <div className='login-card-header'>
                        <h3 className='fw-bold mb-0' style={{ color: '#fff' }}>{t('forgot.question')}</h3>
                        <p className='mt-2 mb-0' style={{ color: 'rgba(255,255,255,0.8)' }}>{t('forgot.help2')}</p>
                    </div>
                    <div className='login-card-body'>
                        <Form onSubmit={handleSubmit}>
                            <Form.Group className='mb-3'>
                                <Form.Control
                                    type='email'
                                    placeholder={t('forgot.email')}
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    className='login-input'
                                    required
                                />
                            </Form.Group>
                            <Button variant='danger' type='submit' className='w-100 login-submit-btn' disabled={sending}>
                                {sending ? <span className="spinner-border spinner-border-sm"></span> : t('forgot.submit')}
                            </Button>
                        </Form>
                        <div className='text-center mt-4'>
                            <Link to='/' className='text-decoration-none' style={{ color: '#EF0000', fontSize: '14px' }}>
                                {t('passwordreset.cancel')}
                            </Link>
                        </div>
                    </div>
                </div>
                <div className='text-center' style={{ marginTop: '20px' }}><Version /></div>
            </div>
        </div>
    )
}
